// Native & external imports
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// Pipes
import { LocaleCurrencyPipe } from './localecurrency.pipe';
import { LocaleDatePipe } from './localedate.pipe';
import { LocaleOrdinalPipe } from './localeordinal.pipe';
import { SafeHtmlPipe } from './safehtml.pipe';


@NgModule({
  declarations: [
    LocaleCurrencyPipe,
    LocaleDatePipe,
    LocaleOrdinalPipe,
    SafeHtmlPipe
  ],
  exports: [
    LocaleCurrencyPipe,
    LocaleDatePipe,
    LocaleOrdinalPipe,
    SafeHtmlPipe
  ],
  imports: [
    CommonModule
  ]
})
export class LocalePipesModule {}
